import { IntegrationSystems } from 'shared/data-layer/integration';
import * as BillingPlan from 'shared_server_client/types/billing_plan'
export const UNRESTRICTED_INTEGRATIONS = [
  IntegrationSystems.LinkedIn.toString(),
]

export const PLAN_BASED_INTEGRATIONS = [
  IntegrationSystems.API.toString(),
  IntegrationSystems.Fonteva.toString(),
  IntegrationSystems.GrowthZone.toString(),
  IntegrationSystems.HigherLogicMagnetMail.toString(),
  IntegrationSystems.Imis.toString(),
  IntegrationSystems.Impexium.toString(),
  IntegrationSystems.Informz.toString(),
  IntegrationSystems.Instagram.toString(),
  IntegrationSystems.Nimble.toString(),
  IntegrationSystems.NoviAMS.toString(),
  IntegrationSystems.PersonifyMCPro.toString(),
  IntegrationSystems.YourMembership.toString(),
  IntegrationSystems.Zoom.toString(),
]

export const isUnrestrictedIntegration = (integrationSystemsName: string) => {
  return UNRESTRICTED_INTEGRATIONS.indexOf(integrationSystemsName) !== -1
}
export const isPlanBasedIntegration = (integrationSystemsName: string) => {
  return PLAN_BASED_INTEGRATIONS.indexOf(integrationSystemsName) !== -1
}
export const hasIntegrationAccess = (systemName: string, availableFeatures: any[]) => {
  switch (systemName) {
  case IntegrationSystems.Instagram:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.INSTAGRAM_INTEGRATION) > -1
  case IntegrationSystems.YourMembership:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.YOUR_MEMBERSHIP_INTEGRATION) > -1
  case IntegrationSystems.Nimble:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.NIMBLE_INTEGRATION) > -1
  case IntegrationSystems.Fonteva:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.FONTEVA_INTEGRATION) > -1
  case IntegrationSystems.Imis:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.IMIS_INTEGRATION) > -1
  case IntegrationSystems.HigherLogicMagnetMail:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.MAGNET_MAIL_INTEGRATION) > -1
  case IntegrationSystems.Impexium:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.IMPEXIUM_INTEGRATION) > -1
  case IntegrationSystems.Informz:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.INFORMZ_INTEGRATION) > -1
  case IntegrationSystems.PersonifyMCPro:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.PERSONIFY_MC_PRO) > -1
  case IntegrationSystems.Zoom:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.ZOOM_INTEGRATION) > -1
  case IntegrationSystems.API:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.API_INTEGRATION_KEY) > -1
  case IntegrationSystems.GrowthZone:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.GROWTHZONE_INTEGRATION) > -1
  case IntegrationSystems.NoviAMS:
    return availableFeatures.length > 0 &&
      availableFeatures.indexOf(BillingPlan.BillingPlanDetailCode.NOVIAMS_INTEGRATION) > -1
  default:
    return true
  }
}
